import { useSidebar } from '@/components/ui/shadcn/sidebar';
import { useSettings } from '@/contexts/SettingsContext';
import AppLogoIcon from '../layout/AppLogoIcon';

export default function AppLogo() {
    const { settings } = useSettings();
    const { state } = useSidebar();
    const isCollapsed = state === 'collapsed';

    const logoUrl = settings.appLogo ? `/storage/${settings.appLogo}` : null;
    const faviconUrl = settings.appFavicon ? `/storage/${settings.appFavicon}` : null;

    if (isCollapsed) {
        if (faviconUrl) {
            return <img src={faviconUrl} alt="" className="size-5 object-contain" />;
        }
        return <AppLogoIcon className="size-5 fill-current" />;
    }

    if (logoUrl) {
        return <img src={logoUrl} alt="Logo" className="h-7 w-auto max-w-[180px] object-contain" />;
    }

    return <AppLogoIcon className="size-7 fill-current" />;
}
